// extracted by mini-css-extract-plugin
export var content = "styles-module--content--406be";
export var contentWrapper = "styles-module--contentWrapper--7f4d9";
export var howToComplainWrapper = "styles-module--howToComplainWrapper--e51da";
export var notice = "styles-module--notice--31b1d";
export var p_table = "styles-module--p_table--352a1";
export var sidebarWrapper = "styles-module--sidebarWrapper--a755a";
export var subHeading = "styles-module--subHeading--1a9c4";
export var text = "styles-module--text--4e2af";
export var title = "styles-module--title--68296";
export var wrapper = "styles-module--wrapper--4ac01";